//export const hostUrlBase = 'https://localhost:5002';
//export const hostUrlBase = 'http://localhost:5003';
//export const hostUrlBase = 'https://www.tecsupdigital.pe/ChinalcoAD-API';
//export const hostUrlBase = 'https://tecsupdigital.pe/ChinalcoP-API';
export const hostUrlBase = 'https://manualoperaciones.chinalco.com.pe/chinalcop-api';

export const hostUrlApi = `${hostUrlBase}/api`;
